import { browser } from "$app/environment"

export function createScrollAnimation(
  element: Element,
  options?: IntersectionObserverInit,
) {
  if (!browser) return () => {}

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("animate-fade-in-up")
          observer.unobserve(entry.target)
        }
      })
    },
    {
      threshold: 0.1,
      rootMargin: "0px 0px -50px 0px",
      ...options,
    },
  )

  observer.observe(element)
  return () => observer.disconnect()
}

export function createStaggeredAnimation(
  elements: NodeListOf<Element>,
  delay: number = 100,
) {
  if (!browser) return () => {}

  const observers: IntersectionObserver[] = []

  elements.forEach((element, index) => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              entry.target.classList.add("animate-fade-in-up")
            }, index * delay)
            observer.unobserve(entry.target)
          }
        })
      },
      {
        threshold: 0.1,
        rootMargin: "0px 0px -50px 0px",
      },
    )

    observer.observe(element)
    observers.push(observer)
  })

  return () => observers.forEach((observer) => observer.disconnect())
}

export function smoothScrollTo(elementId: string, offset: number = 0) {
  if (!browser) return

  const element = document.getElementById(elementId)
  if (!element) return

  const y = element.getBoundingClientRect().top + window.pageYOffset - offset

  window.scrollTo({
    top: y,
    behavior: "smooth",
  })
}
